export const environment = {
  production: true,
  apiURL: '/r/api/v1/',
  wsURL: '/r/websocket',
}
